import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TrendingUp, Target, MessageSquare } from "lucide-react";
import { processData } from "../../../../data/process";
import "./Process.css";

gsap.registerPlugin(ScrollTrigger);

const iconMap = {
  Target: <Target size={28} strokeWidth={1.5} />,
  MessageSquare: <MessageSquare size={28} strokeWidth={1.5} />,
};

const Process = () => {
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const leftElements = leftRef.current.querySelectorAll(".animate-left");
      gsap.fromTo(
        leftElements,
        { opacity: 0, x: -50, y: 20 },
        {
          opacity: 1,
          x: 0,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      const features = leftRef.current.querySelectorAll(".process-feature");
      gsap.fromTo(
        features,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: leftRef.current,
            start: "top 65%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      gsap.fromTo(
        imageRef.current,
        { opacity: 0, x: 50, scale: 0.95 },
        {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="process" ref={sectionRef}>
      <div className="process__container">
        <div className="process__left" ref={leftRef}>
          <div className="process__badge animate-left">{processData.badge}</div>

          <div className="process__icon-wrapper animate-left">
            <TrendingUp size={32} strokeWidth={1.5} />
          </div>

          <h2 className="process__headline animate-left">
            {processData.headline}
          </h2>

          <p className="process__description animate-left">
            {processData.description}
          </p>

          <div className="process__features">
            {processData.features.map((feature, index) => (
              <div key={index} className="process-feature">
                <div className="process-feature__icon-wrapper">
                  {iconMap[feature.iconName]}
                </div>
                <div className="process-feature__content">
                  <h3 className="process-feature__title">{feature.title}</h3>
                  <p className="process-feature__description">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="process__right">
          <div className="process__image" ref={imageRef}>
            <img src={processData.image} alt="Our Process" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
